import { SendBirdContext } from "providers";
import { useContext } from "react";

export const useSendBird = () => useContext(SendBirdContext);
